import { Component } from '@angular/core';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-gizlilik-politikasi',
  standalone: true,
  imports: [NewsletterComponent],
  templateUrl: './gizlilik-politikasi.component.html',
  styleUrl: './gizlilik-politikasi.component.css'
})
export class GizlilikPolitikasiComponent {

}
